import React from "react";

export const CoolIcon: React.FC = () => (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.52422 11.6568L0.574219 6.70677L1.98822 5.29277L5.52572 8.82627L5.52422 8.82777L14.0092 0.342773L15.4232 1.75677L6.93822 10.2428L5.52522 11.6558L5.52422 11.6568Z" fill="#CAD753"/>
    </svg>
);
